import { useEffect } from 'react'
import { useAuth0 } from 'app/Auth'
import { removeGuestToken } from 'lib/services/restApi/getAccessToken'

function Logout() {
  const { logout } = useAuth0()

  useEffect(() => {
    logout({ returnTo: `${window.location.origin}/?status=loggedout` })
    removeGuestToken()
  }, [logout])

  return null
}

export default Logout
